{
  "labels": {
    "paste": "Incolla",
    "pasteAsPlaintext": "Incolla come testo normale",
    "pasteCharts": "Incolla grafici",
    "selectAll": "Seleziona tutto",
    "multiSelect": "Aggiungi elemento alla selezione",
    "moveCanvas": "Sposta tela",
    "cut": "Taglia",
    "copy": "Copia",
    "copyAsPng": "Copia negli appunti come PNG",
    "copyAsSvg": "Copia negli appunti come SVG",
    "copyText": "Copia negli appunti come testo",
    "copySource": "Copia sorgente negli appunti",
    "convertToCode": "Converti in codice",
    "bringForward": "Porta avanti",
    "sendToBack": "Manda in fondo",
    "bringToFront": "Porta in cima",
    "sendBackward": "Manda dietro",
    "delete": "Elimina",
    "copyStyles": "Copia stili",
    "pasteStyles": "Incolla stili",
    "stroke": "Tratto",
    "background": "Sfondo",
    "fill": "Riempimento",
    "strokeWidth": "Spessore del tratto",
    "strokeStyle": "Stile del tratto",
    "strokeStyle_solid": "Pieno",
    "strokeStyle_dashed": "Tratteggiato",
    "strokeStyle_dotted": "Punteggiato",
    "sloppiness": "Imprecisione",
    "opacity": "Opacità",
    "textAlign": "Allineamento del testo",
    "edges": "Bordi",
    "sharp": "Acuto",
    "round": "Rotondo",
    "arrowheads": "Punta della freccia",
    "arrowhead_none": "Nessuno",
    "arrowhead_arrow": "Freccia",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "Cerchio",
    "arrowhead_circle_outline": "Cerchio (contorno)",
    "arrowhead_triangle": "Triangolo",
    "arrowhead_triangle_outline": "Triangolo (contorno)",
    "arrowhead_diamond": "Diamante",
    "arrowhead_diamond_outline": "Diamante (contorno)",
    "fontSize": "Dimensione carattere",
    "fontFamily": "Carattere",
    "addWatermark": "Aggiungi \"Creato con Excalidraw\"",
    "handDrawn": "A mano libera",
    "normal": "Normale",
    "code": "Codice",
    "small": "Piccolo",
    "medium": "Medio",
    "large": "Grande",
    "veryLarge": "Molto grande",
    "solid": "Pieno",
    "hachure": "Tratteggio obliquo",
    "zigzag": "Zig zag",
    "crossHatch": "Tratteggio incrociato",
    "thin": "Sottile",
    "bold": "Grassetto",
    "left": "Sinistra",
    "center": "Centro",
    "right": "Destra",
    "extraBold": "Extra Grassetto",
    "architect": "Architetto",
    "artist": "Artista",
    "cartoonist": "Fumettista",
    "fileTitle": "Nome del file",
    "colorPicker": "Selettore colore",
    "canvasColors": "Usato su tela",
    "canvasBackground": "Sfondo tela",
    "drawingCanvas": "Area di disegno",
    "layers": "Livelli",
    "actions": "Azioni",
    "language": "Lingua",
    "liveCollaboration": "Collaborazione dal vivo...",
    "duplicateSelection": "Duplica",
    "untitled": "Senza titolo",
    "name": "Nome",
    "yourName": "Il vostro nome",
    "madeWithExcalidraw": "Creato con Excalidraw",
    "group": "Crea gruppo da selezione",
    "ungroup": "Dividi gruppo da selezione",
    "collaborators": "Collaboratori",
    "showGrid": "Visualizza griglia",
    "addToLibrary": "Aggiungi alla libreria",
    "removeFromLibrary": "Rimuovi dalla libreria",
    "libraryLoadingMessage": "Caricamento libreria…",
    "libraries": "Sfoglia librerie",
    "loadingScene": "Caricamento della scena…",
    "align": "Allinea",
    "alignTop": "Allinea in alto",
    "alignBottom": "Allinea in basso",
    "alignLeft": "Allinea a sinistra",
    "alignRight": "Allinea a destra",
    "centerVertically": "Centra Verticalmente",
    "centerHorizontally": "Centra orizzontalmente",
    "distributeHorizontally": "Distribuisci orizzontalmente",
    "distributeVertically": "Distribuisci verticalmente",
    "flipHorizontal": "Capovolgi orizzontalmente",
    "flipVertical": "Capovolgi verticalmente",
    "viewMode": "Modalità visualizzazione",
    "share": "Condividi",
    "showStroke": "Mostra selettore colore del tratto",
    "showBackground": "Mostra selettore colore di sfondo",
    "toggleTheme": "Cambia tema",
    "personalLib": "Libreria Personale",
    "excalidrawLib": "Libreria di Excalidraw",
    "decreaseFontSize": "Riduci dimensione dei caratteri",
    "increaseFontSize": "Aumenta la dimensione dei caratteri",
    "unbindText": "Scollega testo",
    "bindText": "Associa il testo al container",
    "createContainerFromText": "Avvolgi il testo in un container",
    "link": {
      "edit": "Modifica link",
      "editEmbed": "Modifica collegamento e incorpora",
      "create": "Crea link",
      "createEmbed": "Crea collegamento e incorpora",
      "label": "Link",
      "labelEmbed": "Collega & incorpora",
      "empty": "Nessun collegamento impostato"
    },
    "lineEditor": {
      "edit": "Modifica linea",
      "exit": "Esci dall'editor di linea"
    },
    "elementLock": {
      "lock": "Blocca",
      "unlock": "Sblocca",
      "lockAll": "Blocca tutto",
      "unlockAll": "Sblocca tutto"
    },
    "statusPublished": "Pubblicato",
    "sidebarLock": "Mantieni aperta la barra laterale",
    "selectAllElementsInFrame": "Seleziona tutti gli elementi nel riquadro",
    "removeAllElementsFromFrame": "Rimuovi tutti gli elementi dal riquadro",
    "eyeDropper": "Scegli il colore della tela",
    "textToDiagram": "Testo a diagramma",
    "prompt": "Prompt"
  },
  "library": {
    "noItems": "Nessun elemento ancora aggiunto...",
    "hint_emptyLibrary": "Seleziona un elemento sulla tela per aggiungerlo qui, o installa una libreria dal repository pubblico qui sotto.",
    "hint_emptyPrivateLibrary": "Seleziona un elemento sulla tela per aggiungerlo qui."
  },
  "buttons": {
    "clearReset": "Svuota la tela",
    "exportJSON": "Esporta su file",
    "exportImage": "Esporta immagine...",
    "export": "Salva in...",
    "copyToClipboard": "Copia negli appunti",
    "save": "Salva sul file corrente",
    "saveAs": "Salva con nome",
    "load": "Apri",
    "getShareableLink": "Ottieni link condivisibile",
    "close": "Chiudi",
    "selectLanguage": "Seleziona lingua",
    "scrollBackToContent": "Scorri indietro fino al contenuto",
    "zoomIn": "Aumenta ingrandimento",
    "zoomOut": "Riduci ingrandimento",
    "resetZoom": "Ripristina ingrandimento",
    "menu": "Menù",
    "done": "Fatto",
    "edit": "Modifica",
    "undo": "Annulla",
    "redo": "Ripeti",
    "resetLibrary": "Ripristina libreria",
    "createNewRoom": "Crea nuova stanza",
    "fullScreen": "Schermo intero",
    "darkMode": "Tema scuro",
    "lightMode": "Tema chiaro",
    "zenMode": "Modalità Zen",
    "objectsSnapMode": "Aggancia agli oggetti",
    "exitZenMode": "Uscire dalla modalità zen",
    "cancel": "Annulla",
    "clear": "Cancella",
    "remove": "Rimuovi",
    "embed": "Attiva/disattiva incorporamento",
    "publishLibrary": "Pubblica",
    "submit": "Invia",
    "confirm": "Conferma",
    "embeddableInteractionButton": "Clicca per interagire"
  },
  "alerts": {
    "clearReset": "Questa azione cancellerà l'intera tela. Sei sicuro?",
    "couldNotCreateShareableLink": "Non riesco a creare un link condivisibile.",
    "couldNotCreateShareableLinkTooBig": "Impossibile creare il link condivisibile: la scena è troppo grande",
    "couldNotLoadInvalidFile": "Impossibile caricare un file no valido",
    "importBackendFailed": "Importazione dal server fallita.",
    "cannotExportEmptyCanvas": "Non è possibile esportare una tela vuota.",
    "couldNotCopyToClipboard": "Impossibile copiare negli appunti.",
    "decryptFailed": "Impossibile decriptare i dati.",
    "uploadedSecurly": "L'upload è stato protetto con la crittografia end-to-end, il che significa che il server Excalidraw e terze parti non possono leggere il contenuto.",
    "loadSceneOverridePrompt": "Se carichi questo disegno esterno, sostituirà quello che hai. Vuoi continuare?",
    "collabStopOverridePrompt": "Interrompere la sessione sovrascriverà il precedente disegno memorizzato localmente. Sei sicuro?\n\n(Se vuoi mantenere il tuo disegno locale, chiudi semplicemente la scheda del browser.)",
    "errorAddingToLibrary": "Impossibile aggiungere l'elemento alla libreria",
    "errorRemovingFromLibrary": "Impossibile rimuovere l'elemento dalla libreria",
    "confirmAddLibrary": "Questo aggiungerà {{numShapes}} forma(e) alla tua libreria. Sei sicuro?",
    "imageDoesNotContainScene": "Questa immagine pare non contenere alcuna scena. Avevi incluso la scena durante l'esportazione?",
    "cannotRestoreFromImage": "Impossibile ripristinare la scena da questo file immagine",
    "invalidSceneUrl": "Impossibile importare la scena dall'URL fornito. Potrebbe essere malformato o non contenere dati JSON Excalidraw validi.",
    "resetLibrary": "Questa azione cancellerà l'intera libreria. Sei sicuro?",
    "removeItemsFromsLibrary": "Eliminare {{count}} elementi dalla libreria?",
    "invalidEncryptionKey": "La chiave di cifratura deve essere composta da 22 caratteri. La collaborazione live è disabilitata.",
    "collabOfflineWarning": "Nessuna connessione internet disponibile.\nLe tue modifiche non verranno salvate!"
  },
  "errors": {
    "unsupportedFileType": "Tipo di file non supportato.",
    "imageInsertError": "Non è stato possibile inserire l'immagine. Riprova più tardi...",
    "fileTooBig": "Il file è troppo grande. La dimensione massima consentita è {{maxSize}}.",
    "svgImageInsertError": "Impossibile inserire l'immagine SVG. Il markup SVG non sembra corretto.",
    "failedToFetchImage": "Impossibile recuperare l'immagine.",
    "invalidSVGString": "SVG non valido.",
    "cannotResolveCollabServer": "Impossibile connettersi al server di collab. Ricarica la pagina e riprova.",
    "importLibraryError": "Impossibile caricare la libreria",
    "collabSaveFailed": "Impossibile salvare nel database di backend. Se i problemi persistono, dovresti salvare il tuo file localmente per assicurarti di non perdere il tuo lavoro.",
    "collabSaveFailed_sizeExceeded": "Impossibile salvare nel database di backend, la tela sembra essere troppo grande. Dovresti salvare il file localmente per assicurarti di non perdere il tuo lavoro.",
    "imageToolNotSupported": "Le immagini sono disabilitate.",
    "brave_measure_text_error": {
      "line1": "Sembra che tu stia utilizzando il browser Brave con l'impostazione <bold>Blocco aggressivo delle impronte digitali</bold> abilitata.",
      "line2": "Ciò potrebbe causare la rottura degli <bold>Elementi di testo</bold> nei tuoi disegni.",
      "line3": "Consigliamo vivamente di disabilitare questa impostazione. Puoi seguire <link>questi passaggi</link> su come farlo.",
      "line4": "Se la disattivazione di questa impostazione non risolve la visualizzazione degli elementi di testo, apri un <issueLink>problema</issueLink> sul nostro GitHub o scrivici su <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Gli elementi incorporabili non possono essere aggiunti alla libreria.",
      "iframe": "Gli elementi IFrame non possono essere aggiunti alla libreria.",
      "image": "Il supporto per l'aggiunta d'immagini alla libreria verrà aggiunto a breve!"
    },
    "asyncPasteFailedOnRead": "Impossibile incollare (non è possibile leggere dagli appunti di sistema).",
    "asyncPasteFailedOnParse": "Impossibile incollare.",
    "copyToSystemClipboardFailed": "Impossibile copiare negli appunti."
  },
  "toolBar": {
    "selection": "Selezione",
    "image": "Inserisci immagine",
    "rectangle": "Rettangolo",
    "diamond": "Rombo",
    "ellipse": "Ellisse",
    "arrow": "Freccia",
    "line": "Linea",
    "freedraw": "Disegno",
    "text": "Testo",
    "library": "Libreria",
    "lock": "Mantieni lo strumento selezionato attivo dopo aver disegnato",
    "penMode": "Modalità penna - previene il tocco",
    "link": "Aggiungi/ aggiorna il link per una forma selezionata",
    "eraser": "Gomma",
    "frame": "Strumento riquadro",
    "magicframe": "",
    "embeddable": "Incorporamento Web",
    "laser": "Puntatore laser",
    "hand": "Mano (strumento di panoramica)",
    "extraTools": "Altri strumenti",
    "mermaidToExcalidraw": "",
    "magicSettings": "Impostazioni di IA"
  },
  "headings": {
    "canvasActions": "Azioni sulla Tela",
    "selectedShapeActions": "Impostazioni della forma selezionata",
    "shapes": "Forme"
  },
  "hints": {
    "canvasPanning": "Per spostare la tela, tieni premuta la rotellina del mouse o la barra spaziatrice mentre trascini oppure usa lo strumento mano",
    "linearElement": "Clicca per iniziare una linea in più punti, trascina per singola linea",
    "freeDraw": "Clicca e trascina, rilascia quando avrai finito",
    "text": "Suggerimento: puoi anche aggiungere del testo facendo doppio clic ovunque con lo strumento di selezione",
    "embeddable": "Fare click e trascina per creare un incorporamento web",
    "text_selected": "Fai doppio click o premi INVIO per modificare il testo",
    "text_editing": "Premi ESC o CtrlOCmd+INVIO per completare le modifiche",
    "linearElementMulti": "Clicca sull'ultimo punto o premi Esc o Invio per finire",
    "lockAngle": "Puoi limitare l'angolo tenendo premuto SHIFT",
    "resize": "Per vincolare le proporzioni, tieni premuto MAIUSC durante il ridimensionamento;\nper ridimensionare dal centro, tieni premuto ALT",
    "resizeImage": "Puoi ridimensionare liberamente tenendo premuto SHIFT,\ntieni premuto ALT per ridimensionare dal centro",
    "rotate": "Puoi mantenere gli angoli tenendo premuto SHIFT durante la rotazione",
    "lineEditor_info": "Tieni premuto Ctrl o Cmd e doppio clic oppure premi Ctrl o Cmd + Invio per modificare i punti",
    "lineEditor_pointSelected": "Premi Elimina per rimuovere il punto(i),\nCtrlOCmd+D per duplicare o trascinare per spostare",
    "lineEditor_nothingSelected": "Seleziona un punto da modificare (tieni premuto MAIUSC per selezionare più punti),\noppure tieni premuto Alt e fai clic per aggiungere nuovi punti",
    "placeImage": "Fai click per posizionare l'immagine, o click e trascina per impostarne la dimensione manualmente",
    "publishLibrary": "Pubblica la tua libreria",
    "bindTextToElement": "Premi invio per aggiungere il testo",
    "deepBoxSelect": "Tieni premuto CtrlOCmd per selezionare in profondità e per impedire il trascinamento",
    "eraserRevert": "Tieni premuto Alt per ripristinare gli elementi contrassegnati per l'eliminazione",
    "firefox_clipboard_write": "Questa funzione può essere abilitata impostando il flag \"dom.events.asyncClipboard.clipboardItem\" su \"true\". Per modificare i flag del browser in Firefox, visitare la pagina \"about:config\".",
    "disableSnapping": "Tieni premuto Ctrl o Cmd per disabilitare lo snap"
  },
  "canvasError": {
    "cannotShowPreview": "Impossibile visualizzare l'anteprima",
    "canvasTooBig": "La tela potrebbe essere troppo grande.",
    "canvasTooBigTip": "Suggerimento: prova a spostare gli elementi più lontani più vicini tra loro."
  },
  "errorSplash": {
    "headingMain": "Si è verificato un errore. Provare <button>ricaricando la pagina.</button>",
    "clearCanvasMessage": "Se ricaricare non funziona, prova <button>pulire la tela.</button>",
    "clearCanvasCaveat": " Questo risulterà nella perdita del lavoro ",
    "trackedToSentry": "L'errore con identificativo {{eventId}} è stato tracciato nel nostro sistema.",
    "openIssueMessage": "Siamo stati molto cauti nel non includere informazioni della scena nell'errore. Se la tua scena non è privata, ti preghiamo di considerare la sua inclusione nel nostro <button>bug tracker.</button> Per favore includi le informazioni riportate qui sotto copiandole e incollandole nella issue di GitHub.",
    "sceneContent": "Contenuto della scena:"
  },
  "roomDialog": {
    "desc_intro": "Puoi invitare persone nella tua scena attuale per collaborare con te.",
    "desc_privacy": "Non preoccuparti, la sessione utilizza la crittografia end-to-end, quindi qualsiasi cosa disegni rimarrà privata. Nemmeno il nostro server sarà in grado di vedere cosa hai creato.",
    "button_startSession": "Avvia sessione",
    "button_stopSession": "Termina sessione",
    "desc_inProgressIntro": "La sessione di collaborazione è attualmente in corso.",
    "desc_shareLink": "Condividi questo link con chiunque desideri collaborare:",
    "desc_exitSession": "Interrompere la sessione scollegherà la tua stanza ma potrai continuare a lavorare con la scena, localmente. Tieni presente che questo non influirà sulle altre persone, e che saranno ancora in grado di collaborare alla loro versione.",
    "shareTitle": "Partecipa a una sessione di collaborazione live su Excalidraw"
  },
  "errorDialog": {
    "title": "Errore"
  },
  "exportDialog": {
    "disk_title": "Salva su disco",
    "disk_details": "Esporta i dati della scena su file, dal quale potrai importare in seguito.",
    "disk_button": "Salva su file",
    "link_title": "Link condivisibile",
    "link_details": "Esporta come link di sola lettura.",
    "link_button": "Esporta come Link",
    "excalidrawplus_description": "Salva la scena nel tuo spazio di lavoro Excalidraw+.",
    "excalidrawplus_button": "Esporta",
    "excalidrawplus_exportError": "Non è stato possibile esportare su Excalidraw+ al questo momento..."
  },
  "helpDialog": {
    "blog": "Leggi il nostro blog",
    "click": "click",
    "deepSelect": "Selezione profonda",
    "deepBoxSelect": "Seleziona in profondità all'interno della casella e previene il trascinamento",
    "curvedArrow": "Freccia curva",
    "curvedLine": "Linea curva",
    "documentation": "Documentazione",
    "doubleClick": "doppio-click",
    "drag": "trascina",
    "editor": "Editor",
    "editLineArrowPoints": "Modifica punti linea/freccia",
    "editText": "Modifica testo / aggiungi etichetta",
    "github": "Trovato un problema? Segnalalo",
    "howto": "Segui le nostre guide",
    "or": "oppure",
    "preventBinding": "Impedisci legame della freccia",
    "tools": "Stumenti",
    "shortcuts": "Scorciatoie da tastiera",
    "textFinish": "Completa la modifica (editor di testo)",
    "textNewLine": "Aggiungi nuova riga (editor di testo)",
    "title": "Guida",
    "view": "Vista",
    "zoomToFit": "Adatta zoom per mostrare tutti gli elementi",
    "zoomToSelection": "Zoom alla selezione",
    "toggleElementLock": "Blocca/sblocca selezione",
    "movePageUpDown": "Sposta la pagina su/giù",
    "movePageLeftRight": "Sposta la pagina a sinistra/destra"
  },
  "clearCanvasDialog": {
    "title": "Svuota la tela"
  },
  "publishDialog": {
    "title": "Pubblica la libreria",
    "itemName": "Nome dell'elemento",
    "authorName": "Nome dell'autore",
    "githubUsername": "Nome utente di GitHub",
    "twitterUsername": "Nome utente di Twitter",
    "libraryName": "Nome della libreria",
    "libraryDesc": "Descrizione della libreria",
    "website": "Sito Web",
    "placeholder": {
      "authorName": "Il tuo nome o nome utente",
      "libraryName": "Nome della tua libreria",
      "libraryDesc": "Descrizione della tua libreria per aiutare le persone a comprenderne lo scopo",
      "githubHandle": "Handle di GitHub (opzionale), così che tu possa modificare la libreria una volta inviata per la revisione",
      "twitterHandle": "Nome utente di Twitter (opzionale), così che sappiamo chi accreditare promuovendo su Twitter",
      "website": "Link al tuo sito web personale o altro (opzionale)"
    },
    "errors": {
      "required": "Obbligatorio",
      "website": "Inserisci un URL valido"
    },
    "noteDescription": "Invia la tua libreria da includere nella <link>repository della libreria pubblica</link>perché sia usata da altri nei loro disegni.",
    "noteGuidelines": "La libreria dev'esser prima approvata manualmente. Sei pregato di leggere le <link>linee guida</link> prima di inviarla. Necessiterai di un profilo di GitHub per comunicare ed effettuare modifiche se richiesto, ma non è strettamente necessario.",
    "noteLicense": "Inviando, acconsenti che la libreria sarà pubblicata sotto la <link>Licenza MIT, </link>che in breve significa che chiunque possa usarla senza restrizioni.",
    "noteItems": "Ogni elemento della libreria deve avere il proprio nome, così che sia filtrabile. Gli elementi della seguente libreria saranno inclusi:",
    "atleastOneLibItem": "Sei pregato di selezionare almeno un elemento della libreria per iniziare",
    "republishWarning": "Nota: alcuni degli elementi selezionati sono contrassegnati come già pubblicati/presentati. È necessario reinviare gli elementi solo quando si aggiorna una libreria o una presentazione esistente."
  },
  "publishSuccessDialog": {
    "title": "Libreria inviata",
    "content": "Grazie {{authorName}}. La tua libreria è stata inviata per la revisione. Puoi monitorarne lo stato<link>qui</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Ripristina la libreria",
    "removeItemsFromLib": "Rimuovi gli elementi selezionati dalla libreria"
  },
  "imageExportDialog": {
    "header": "Esporta immagine",
    "label": {
      "withBackground": "Sfondo",
      "onlySelected": "Solo selezionato",
      "darkMode": "Tema scuro",
      "embedScene": "Includi scena",
      "scale": "Scala",
      "padding": "Rientro"
    },
    "tooltip": {
      "embedScene": "I dati della scena saranno salvati nel file PNG/SVG esportato in modo che la scena possa essere ripristinata da esso.\nQuesto aumenterà la dimensione del file esportato."
    },
    "title": {
      "exportToPng": "Esporta come PNG",
      "exportToSvg": "Esporta come SVG",
      "copyPngToClipboard": "Copia PNG negli appunti"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copia negli appunti"
    }
  },
  "encrypted": {
    "tooltip": "I tuoi disegni sono crittografati end-to-end in modo che i server di Excalidraw non li possano mai vedere.",
    "link": "Articolo del blog sulla crittografia end-to-end di Excalidraw"
  },
  "stats": {
    "angle": "Angolo",
    "element": "Elemento",
    "elements": "Elementi",
    "height": "Altezza",
    "scene": "Scena",
    "selected": "Selezionato",
    "storage": "Memoria",
    "title": "Statistiche per nerd",
    "total": "Totale",
    "version": "Versione",
    "versionCopy": "Clicca per copiare",
    "versionNotAvailable": "Versione non disponibile",
    "width": "Larghezza"
  },
  "toast": {
    "addedToLibrary": "Aggiunto alla libreria",
    "copyStyles": "Stili copiati.",
    "copyToClipboard": "Copiato negli appunti.",
    "copyToClipboardAsPng": "{{exportSelection}} copiato negli appunti come PNG\n({{exportColorScheme}})",
    "fileSaved": "File salvato.",
    "fileSavedToFilename": "Salvato in {filename}",
    "canvas": "tela",
    "selection": "selezione",
    "pasteAsSingleElement": "Usa {{shortcut}} per incollare come un singolo elemento,\no incollare in un editor di testo esistente",
    "unableToEmbed": "Incorporare questo url non è permesso. Crea una issue su GitHub per richiedere che l'url sia autorizzato",
    "unrecognizedLinkFormat": "Il link che hai incorporato non corrisponde al formato previsto. Prova a incollare la stringa 'embed' fornita dal sito di origine"
  },
  "colors": {
    "transparent": "Trasparente",
    "black": "Nero",
    "white": "Bianco",
    "red": "Rosso",
    "pink": "Rosa",
    "grape": "Uva",
    "violet": "Viola",
    "gray": "Grigio",
    "blue": "Blu",
    "cyan": "Ciano",
    "teal": "Verde acqua",
    "green": "Verde",
    "yellow": "Giallo",
    "orange": "Arancio",
    "bronze": "Bronzo"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Tutti i tuoi dati sono salvati localmente nel browser.",
      "center_heading_plus": "Volevi invece andare su Excalidraw+?",
      "menuHint": "Esporta, preferenze, lingue, ..."
    },
    "defaults": {
      "menuHint": "Esporta, preferenze, e altro...",
      "center_heading": "Diagrammi. Fatto. Semplice.",
      "toolbarHint": "Scegli uno strumento & Inizia a disegnare!",
      "helpHint": "Scorciatoie & aiuto"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Colori personalizzati più utilizzati",
    "colors": "Colori",
    "shades": "Sfumature",
    "hexCode": "Codice esadecimale",
    "noShades": "Nessuna sfumatura disponibile per questo colore"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Esporta come immagine",
        "button": "Esporta come immagine",
        "description": "Esporta i dati della scena come immagine, che potrai importare in seguito."
      },
      "saveToDisk": {
        "title": "Salva su disco",
        "button": "Salva su disco",
        "description": "Esporta i dati della scena su file, che potrai importare in seguito."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Esporta su Excalidraw+",
        "description": "Salva la scena sul tuo spazio di lavoro Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Carica da file",
        "button": "Carica da file",
        "description": "Il caricamento da file sostituirà <bold>il contenuto esistente</bold>.<br></br>Puoi salvare il tuo disegno prima usando una delle opzioni qui sotto."
      },
      "shareableLink": {
        "title": "Carica da link",
        "button": "Sostituisci il mio contenuto",
        "description": "Il caricamento da file sostituirà <bold>il contenuto esistente</bold>.<br></br>Puoi salvare il tuo disegno prima usando una delle opzioni qui sotto."
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "Inserisci",
    "description": "",
    "syntax": "",
    "preview": "Anteprima"
  }
}
